var _linearGradient, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPubsub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    viewBox: "-1.63323543 7.03260933 131.26574682 114.43939067",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 64,
    x2: 64,
    y1: 7.034,
    y2: 120.789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4387fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4683ea"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.79 115.217-26.25-45.468a11.499 11.499 0 0 1 0-11.499l26.25-45.467a11.5 11.5 0 0 1 9.96-5.75h52.5a11.5 11.5 0 0 1 9.959 5.75l26.25 45.467a11.499 11.499 0 0 1 0 11.5l-26.25 45.467a11.5 11.5 0 0 1 -9.959 5.749h-52.5a11.499 11.499 0 0 1 -9.96-5.75z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m121.054 79.58-31.836-31.834-5.858 1.214-14.603-14.602-4.673 8.739-2.534 10.109 4.289 4.29-8.238 1.682-11.296-11.296-7.67 7.373 14.123 14.125-14.97 11.9 40.193 40.192 19.581-.19z",
    opacity: 0.07
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85.519,
    cy: 51.576,
    r: 5.324
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.48,
    cy: 51.576,
    r: 5.324
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 88.849,
    r: 5.325
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 8.602
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.48,
    cy: 76.424,
    r: 6.758
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.519,
    cy: 76.424,
    r: 6.758
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 39.151,
    r: 6.759
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPubsub);
export default __webpack_public_path__ + "static/media/pubsub.a3571be2ae814b150636c206eb9fd0a8.svg";
export { ForwardRef as ReactComponent };